import { useEffect, useState } from "react";
import { Button, Heading } from "react-bulma-components";
import { getOrCreateSocket } from "socket/socket";
import styles from "./styles.module.scss";
import { useT } from "i18n/I18nProvider";

export const FSLoader = () => {
  const [showReconnectButton, setShowReconnectButton] = useState(false);
  const t = useT();
  useEffect(() => {
    if (!showReconnectButton) {
      const timeout = setTimeout(() => {
        setShowReconnectButton(true);
      }, 5000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showReconnectButton]);
  return (
    <div className={styles.container}>
      <Heading size={5} weight="normal">
        {t("fsloader.waiting")}
      </Heading>
      <span className={styles.loader}></span>
      {showReconnectButton && (
        <Button
          onClick={() => {
            const socket = getOrCreateSocket();
            socket.connect();
            setShowReconnectButton(false);
          }}
        >
          {t("fsloader.retry")}
        </Button>
      )}
    </div>
  );
};
